// @flow

import React from 'react';
import { Wrapper } from '@riseart/layout';
import { FilterBuilder, FilterContainerLoader } from '@riseart/filter';
import { ArtistListFilterModel } from 'shared_models/filters/ArtistList';
import type { FilterContainerProps } from 'shared_hocs/filters/Container';

/**
 * ArtistFiltersList
 *
 * @param {FilterContainerProps} props
 */
export const ArtistFiltersList = ({ isLoading, ...restProps }: FilterContainerProps) => (
  <FilterContainerLoader component={Wrapper} isLoading={isLoading}>
    <FilterBuilder {...restProps} config={ArtistListFilterModel} />
  </FilterContainerLoader>
);
